import { motion } from 'framer-motion'
import { Users } from 'lucide-react'

interface Founder {
  name: string
  role: string
  bio: string
}

const founders: Founder[] = [
  {
    name: 'Guilherme Lima',
    role: 'Co-founder · Arquiteto e Líder Técnico',
    bio: 'Com vasta experiência em desenvolvimento de software no Brasil e exterior, lidera equipes com práticas ágeis e inovação contínua. Foco em soluções escaláveis que atendem diretamente às necessidades dos clientes.',
  },
  {
    name: 'Gustavo Lopes',
    role: 'Co-founder · Arquiteto e Desenvolvedor de Software',
    bio: 'Foco em conectar negócio e tecnologia. Atua em projetos de modernização empresarial e de processos, com skillset único adquirido em graduação e pós em Engenharia de Software, Contabilidade e Direito.',
  },
  {
    name: 'Leonardo Reis',
    role: 'Co-founder · Líder Técnico e Desenvolvedor',
    bio: 'Conecta as necessidades técnicas aos profissionais capacitados. Atua na organização das equipes, alocação de perfis e na evolução dos profissionais — planejando e auxiliando suas trilhas de aprendizado.',
  },
]

export function Team() {
  return (
    <section id="equipe" className="py-20 md:py-28 bg-secondary/30 border-y border-border/30">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <div className="text-sm font-semibold tracking-wider text-brand-cyan uppercase mb-3">
            Nosso time de experts
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
            Quem está por trás da i3
          </h2>
          <p className="mt-4 text-lg text-muted-foreground text-pretty">
            Três co-founders + um time multidisciplinar de front-end, back-end, full-stacks e
            designers prontos pra plugar no seu projeto.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {founders.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="p-6 rounded-xl border border-border/50 bg-card hover:border-brand-cyan/60 hover:shadow-xl hover:shadow-brand-purple/10 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="size-12 rounded-full bg-brand-gradient flex items-center justify-center shrink-0 shadow-lg shadow-brand-purple/30">
                  <span className="text-white font-bold text-lg">
                    {f.name.split(' ').map((n) => n[0]).slice(0, 2).join('')}
                  </span>
                </div>
                <div>
                  <h3 className="text-lg font-semibold">{f.name}</h3>
                  <div className="text-sm text-brand-cyan mb-3">{f.role}</div>
                  <p className="text-sm text-muted-foreground leading-relaxed">{f.bio}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-3 text-sm text-muted-foreground">
          <Users className="size-4 text-brand-cyan" />
          <span>
            <span className="text-foreground font-semibold">+11 outros talentos</span> de front-end,
            back-end, full-stacks e designers prontos pra apoiar seu projeto
          </span>
        </div>
      </div>
    </section>
  )
}
